import { Fragment, ReactNode } from 'react';
import { escapeRegExp } from 'src/utils/strings';

export const HighlightedText = ({
  text,
  query,
}: {
  text: string | null | undefined;
  query: string;
}): ReactNode => {
  const safeText = text ?? '';
  const trimmed = query.trim();

  if (!trimmed) {
    return safeText;
  }

  const parts = safeText.split(new RegExp(`(${escapeRegExp(trimmed)})`, 'gi'));

  if (parts.length === 1) {
    return safeText;
  }

  return parts.map((part, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <Fragment key={index}>{index % 2 === 1 ? <mark>{part}</mark> : part}</Fragment>
  ));
};
